import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import { CurrencyInput } from 'foundations-components/transitional/components/CurrencyInput';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useCallback, useState } from 'react';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
import { formatCentsToDollars, formatDollarsToCents } from 'marketplace-ui-common/utils/currency';
import { debounce } from 'marketplace-ui-common/utils/debounce';
import { View } from 'foundations-components/transitional/components/View';
import { NextIcon } from 'foundations-assets/icons/components/NextIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const floorCentsToNearestDollar = cents => cents - cents % 100;
const minPlaceholderCents = 0;
const maxPlaceholderCents = 10000;
const PriceRangeInput = ({
  onFilterChange,
  priceRangeValue
}) => {
  const [minCents, setMinCents] = useState(priceRangeValue ? priceRangeValue.minCents : null);
  const [maxCents, setMaxCents] = useState(priceRangeValue ? priceRangeValue.maxCents : null);
  const handlePriceRangeChange = useCallback((newMinCents, newMaxCents) => {
    setMinCents(newMinCents);
    setMaxCents(newMaxCents);
    if (newMinCents !== null && newMaxCents !== null) {
      onFilterChange(ThemeQueryField.PRICE_RANGE, {
        minCents: newMinCents,
        maxCents: newMaxCents
      });
    }
  }, [onFilterChange]);
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    wrap: "wrap",
    paddingInlineStart: "600",
    children: [/*#__PURE__*/_jsx(CurrencyInput, {
      "aria-label": unescapedText('marketplace-assets-ui.assets.filters.price.lowestPriceLabel'),
      currency: "USD",
      name: "lowest-price",
      onChange: debounce(evt => handlePriceRangeChange(floorCentsToNearestDollar(formatDollarsToCents(evt.target.value)), maxCents)),
      placeholder: I18n.formatIntlCurrency(formatCentsToDollars(minPlaceholderCents), {
        currencyCode: 'USD'
      }),
      value: minCents ? formatCentsToDollars(minCents) : undefined,
      width: '68px',
      max: maxCents !== null ? formatCentsToDollars(maxCents) : Infinity
    }), /*#__PURE__*/_jsx(View, {
      as: "span",
      marginInline: "200",
      children: /*#__PURE__*/_jsx(NextIcon, {
        size: "300"
      })
    }), /*#__PURE__*/_jsx(CurrencyInput, {
      "aria-label": unescapedText('marketplace-assets-ui.assets.filters.price.highestPriceLabel'),
      currency: "USD",
      name: "highest-price",
      onChange: debounce(evt => handlePriceRangeChange(minCents, floorCentsToNearestDollar(formatDollarsToCents(evt.target.value)))),
      placeholder: I18n.formatIntlCurrency(formatCentsToDollars(maxPlaceholderCents), {
        currencyCode: 'USD'
      }),
      value: maxCents !== null ? formatCentsToDollars(maxCents) : undefined,
      width: '68px',
      min: minCents !== null ? formatCentsToDollars(minCents) : 0
    })]
  });
};
export default PriceRangeInput;